import { Component, OnInit, Input, Output, HostListener, ElementRef, EventEmitter } from '@angular/core';

export interface TangoColorPalette {
	[group: string]: string[]; // e.g. butter: [#fce94f, #edd400]
}

@Component({
	selector: 'app-common-tango-colorpicker',
	templateUrl: './common-tango-colorpicker.component.html',
	styleUrls: ['./common-tango-colorpicker.component.css']
})
export class CommonTangoColorpickerComponent implements OnInit {

	@Input() selectedColor: string;
	@Output() colorChange: EventEmitter<string> = new EventEmitter();

	public colors: string[];
	public showColorPalette: boolean;
	constructor(
		private elemRef: ElementRef,
	) { }

	@HostListener('document:click', ['$event'])
	onDocumentClick(e: MouseEvent) {
		if (e.target && !this.elemRef.nativeElement.contains(e.target)) {
			this.toggleColorPalette(false);
		}
	}


	toggleColorPalette(isShow: boolean) {
		this.showColorPalette = isShow;
	}
	pickColor(color: string) {
		this.selectedColor = color;
		this.toggleColorPalette(false);
		this.colorChange.next(color);
	}

	private getTangoColorPalette(): TangoColorPalette {
		return {
			butter: ['#4e9a06', '#edd400', '#c4a000'],

			// butter: ['#fce94f', '#edd400', '#c4a000'],
			orange: ['#fcaf3e', '#f57900', '#ce5c00'],
			chocolate: ['#e9b96e', '#c17d11', '#8f5902'],
			// chameleon: ['#8ae234', '#73d216', '#4e9a06'],
			skyblue: ['#729fcf', '#3465a4', '#204a87'],
			plum: ['#ad7fa8', '#75507b', '#5c3566'],
			scarletred: ['#ef2929', '#cc0000', '#a40000'],
			aluminium: ['#888a85', '#555753', '#2e3436'] // '#eeeeec', '#d3d7cf', '#babdb6', 
		};
	}
	private initColors() {
		const colorPalette = this.getTangoColorPalette();
		let colors = [];
		for (const group of Object.keys(colorPalette)) {
			colors = colors.concat(colorPalette[group]);
		}
		this.colors = colors;
	}
	ngOnInit() {
		this.initColors();
		// Set default color
		this.selectedColor = this.selectedColor || this.colors[21]; // #eeeeec
		this.colorChange.next(this.selectedColor);
	}

}



// WEBPACK FOOTER //
// ./src/app/components/common-tango-colorpicker/common-tango-colorpicker.component.ts